import type { FaireProductEntity } from "../../entity_types/product";

export const p_qp6u6wanz4: FaireProductEntity = {
  token: "p_qp6u6wanz4",
  type: "product",
  name: "Best Sellers Trial Kit",
  brandToken: "b_eerxm9hive",
  brandName: "Original Moxie",
  imageUrl:
    "https://cdn.faire.com/fastly/830b000417634b5792e7b6c28b4dc3dd71529b3db544d229bca7eb9cd2709aa7.png",
  galleryImageUrls: [],
  priceDollars: 123,
  description:
    "Get to know our hero products with this compact trial kit which includes one 2 - 3.4 oz size of all our best-selling shampoos, conditioners, moisturizers, and definers. \n\nNEW SALONS AND RETAILERS CAN RECEIVE A 15% OFF CODE FOR THIS KIT BY EMAILING JOE HARLOW @ [redacted-email]\nThis Kit Includes: \nOne 3.4 oz Get Clean!™  No Foam Shampoo \nOne 3.4 oz Triple Threat™  Shampoo \nOne 3.4 oz Featherweight™  Conditioner \nOne 3.4 oz Intense Quench™  Deep Conditioner \nOne 3.4 oz Shape Shifter™  Reforming Creme \nOne 3.4 oz Oasis™  Moisture Gel \nOne 3.4 oz Everyday Leave-In™  Moisturizing Cream\nOne 3 oz Lux Locks Ultra-Rich™  Styling Cream\nOne 3.4 oz Just Gel™  Styling Concentrate \nOne 3.4 oz Hold Up™  Defining Serum \nOne 3.4 oz Mane Tame™  Frizz Control Serum \nOne 2 oz Pop Life™  Volumizing Mousse ",
  tags: [],
  msrpDollars: 246,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:13.112Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
